<div class="expand-container">
    <div class="expand-indicator">
        <div class="expand-line"></div>
        <div class="expand-line"></div>
        <div class="expand-line"></div>
    </div>
</div>